/* eslint no-irregular-whitespace: 0 */

import styles from './styles.styl'
import PreactDOM from 'react-dom'
import { Component } from 'preact'
import Diagram from '../diagram'
import { Huge, Regular } from '../text'
import { cc } from '../../utils'

const ITEMS = [ {
  text: 'person',
  preText: 'being a better'
}, {
  text: 'product',
  preText: 'building a better'
}, {
  text: 'team',
  preText: 'building a better'
}, {
  text: 'company',
  preText: 'building a better'
}, {
  text: 'world',
  preText: 'building a better'
} ]

const SIDE_CIRCLE_CLASSNAMES = [
  styles.sideCircle1,
  styles.sideCircle2,
  styles.sideCircle3,
  styles.sideCircle4,
  styles.sideCircle5
]

export function debounce (func, wait) {
  let timeout
  return function executedFunction (...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

const getItemClassName = (selectedItemIndex) =>
  selectedItemIndex > -1
    ? cc(styles.preText)
    : cc(styles.preText, styles.disabled)

class Building extends Component {
  state = {
    selectedItemIndex: 0,
    isDiagramActivated: false,
    observer: null
  }

  selectItem = (index) => {
    const { selectedItemIndex } = this.state
    if (index !== selectedItemIndex) {
      this.setState(({ selectedItemIndex }) => ({
        prevItemIndex: selectedItemIndex,
        selectedItemIndex: index
      }))
    }
  }

  handleMouseMove = debounce((index) => {
    this.selectItem(index)
  }, 100);

  render () {
    const {
      selectedItemIndex,
      prevItemIndex,
      isDiagramActivated
    } = this.state
    const hadPrevItem = prevItemIndex !== null
    const circleClassName = SIDE_CIRCLE_CLASSNAMES[selectedItemIndex]
    const finalCircleClassName = hadPrevItem ? cc(
      circleClassName,
      styles.circleTransition
    ) : SIDE_CIRCLE_CLASSNAMES[selectedItemIndex]

    return (
      <section className={styles.section} id={'programme'}>
        <Regular className={styles.caption}>
          Take the&nbsp;next step in&nbsp;your career and learn how to&nbsp;scale your team, business, and&nbsp;global impact.
        </Regular>

        <div className={styles.sectionContent}>
          <div className={styles.column}>
            <div className={styles.columnWrap}>
              <Regular className={getItemClassName(selectedItemIndex)} aria-hidden>
                {selectedItemIndex !== -1 ? (<span>{ITEMS[selectedItemIndex].preText}</span>)
                  : <span />}
              </Regular>

              <ul
                data-active={this.state.selectedItemIndex}
                className={styles.list}
                onMouseLeave={() => this.selectItem(-1)}
              >

                <div className={finalCircleClassName} aria-hidden />

                {ITEMS.map((item, index) => (
                  <li
                    key={index}
                    className={styles.item}
                    onMouseEnter={() => this.selectItem(index)}
                    onClick={() => this.selectItem(index)}
                  >
                    <Huge className={styles.listTitle} dangerouslySetInnerHTML={{ __html: item.text }} />
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className={styles.diagram}>
            <Diagram selectedIndex={this.state.selectedItemIndex} isActivated={isDiagramActivated} onMouseMove={this.handleMouseMove} />
          </div>
        </div>
      </section>
    )
  }

  handleIntersection = ([{ isIntersecting }], observer) => {
    if (isIntersecting) {
      this.setState({ isDiagramActivated: true })
      const thisElement = PreactDOM.findDOMNode(this)
      observer.unobserve(thisElement)
    }
  }

  componentDidMount () {
    const thisElement = PreactDOM.findDOMNode(this)
    const observer = new window.IntersectionObserver(
      this.handleIntersection,
      { rootMargin: '-20% 0px -70% 0px' }
    )
    observer.observe(thisElement)
    this.setState({ observer })
  }

  componentWillUnmount () {
    const { observer } = this.state
    const thisElement = PreactDOM.findDOMNode(this)
    observer.unobserve(thisElement)
  }
}

export default Building



// WEBPACK FOOTER //
// ./components/building/index.js